<template>
  <form
    ref="form"
    class="news-search"
    :class="{ '-sticky': isSticky }"
    @submit.prevent="submit"
  >
    <div class="grid-2024">
      <div
        class="news-search__row g-col-full g-start-lg-4 g-col-lg-6"
        :class="{ '-search': !isDropdownActive }"
      >
        <div class="news-search__control -input">
          <input
            ref="input"
            v-model="inputValue"
            class="news-search__input"
            type="search"
            :placeholder="t('search_placeholder')"
            @keyup="handleInputKeyup"
          >
          <button
            v-if="inputValue"
            type="button"
            class="news-search__clear t2"
            @click="clearInput"
          >
            {{ t('clear') }}
          </button>
          <button
            type="submit"
            class="news-search__button -magnify"
            :aria-label="t('search_submit')"
            @click="handleSearchButtonClick"
          >
            <FontIcon class="search" size="-m" />
          </button>
        </div>

        <div
          class="news-search__control -combobox"
          :class="{ '-chevron': !isDropdownActive }"
          @click.capture="activateDropdown"
        >
          <Combobox
            :placeholder="comboboxPlaceholder"
            :filterable="false"
            :items="items"
            :show-counter="true"
            :show-clear="false"
            :controls="{
              selected: true,
              unselected: true,
              toggleItemsHandler: toggleAllItems,
            }"
            :on-change="handleSelectionChange"
          />
        </div>
      </div>
    </div>
  </form>
</template>

<script setup lang="ts">
  import { Combobox } from '@nuxt-shared/ui/combobox';
  import { FontIcon } from '@nuxt-shared/ui/font-icon';
  import { useNewsSearchModel } from './model';
  import type { NewsSearchEmits, NewsSearchProps } from './types';

  const props = defineProps<NewsSearchProps>();
  const emit = defineEmits<NewsSearchEmits>();
  const {
    t,
    form,
    input,
    inputValue,
    items,
    isSticky,
    isDropdownActive,
    comboboxPlaceholder,
    submit,
    handleInputKeyup,
    handleSearchButtonClick,
    handleSelectionChange,
    toggleAllItems,
    activateDropdown,
    clearInput,
  } = useNewsSearchModel(props, emit);
</script>

<style lang="scss" scoped>
  @use './style.scss';
</style>

<i18n lang="json" src="./locale.json" />
